import axios from 'axios'
import { Modal } from 'react-bootstrap'
import BASEURL from '../../Config/global'
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

const RemovePlaylistModal = ({ isOpen, onClose, onSuccess }) => {

    const { t } = useTranslation();
    const { selectedId } = useSelector((state) => state.player);

    const handleRemovePlaylist = async () => {
        try {
            const response = await axios.delete(`${BASEURL}/api/user/playlists/${selectedId}/`);
            if (!response.data.error) {
                onSuccess('removed-playlist');
            }
        } catch (error) {
            console.log(error)
        }
    }

    return (
        <div>
            {/* delete modal */}
            <Modal
                show={isOpen}
                centered
                className="soundModal"
                backdrop="static"
            >
                <Modal.Body>
                    <div className="customModalContent my-5">
                        <h2 className="font-16 lh-16 fw-normal mb-5 text-center">{t("playlists.deleteConfirm")}</h2>
                        <div className="mt-4 d-flex align-items-center justify-content-center">
                            <button style={{ backgroundColor: '#ffffff1f' }} className='mx-3 px-5 py-2 fs-6 fw-light text-white text-capitalize btn rounded-pill d-flex align-items-center justify-content-center flex-shrink-0' onClick={handleRemovePlaylist}>
                                <span className=''>{t("playlists.yes")}</span>
                            </button>
                            <button style={{ backgroundColor: '#ffffff1f' }} className='mx-3 px-5 py-2 fs-6 fw-light text-white text-capitalize btn rounded-pill d-flex align-items-center justify-content-center flex-shrink-0' onClick={() => onClose('remove-playlist')}>
                                <span className=''>{t("playlists.no")}</span>
                            </button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default RemovePlaylistModal
